export default "__VITE_ASSET__CxdHldJb__"